<template>
  <v-app :class="this.store.state.global.bodyClass">
    <Sidebar />
    <div id="snackbar">{{this.store.state.global.snackbarText}}</div>
    <div class="container">
      <router-view />
    </div>
  </v-app>
</template>

<script>
import Sidebar from "./components/Sidebar.vue";
import { useStore } from "vuex";
export default {
  name: "App",
  setup() {
    const store = useStore();
    return {
      store,
    };
  },

  data() {
    return {};
  },

  components: {
    Sidebar,
  },

  created() {},

  mounted() {
    if (this.store.state.global.userData.roles.includes("ROLE_OPERATORE")) {
      window.location.href = "/scansiona-colli";
    }
  },
};
</script>

<style scoped>
.container {
  position: absolute;
  height: 100%;
  width: calc(100% - 78px);
  left: 78px;
}

@media screen and (max-width: 420px) {
  .container {
    margin-top: 70px;
    width: 100%;
    left: 0;
  }
}

.formOpen {
  height: 100vh;
  overflow: hidden;
}

#snackbar {
  visibility: hidden; /* Hidden by default. Visible on click */
  min-width: 250px; /* Set a default minimum width */
  margin-left: -125px; /* Divide value of min-width by 2 */
  background-color: #333; /* Black background color */
  color: #fff; /* White text color */
  text-align: center; /* Centered text */
  border-radius: 2px; /* Rounded borders */
  padding: 16px; /* Padding */
  position: fixed; /* Sit on top of the screen */
  z-index: 1; /* Add a z-index if needed */
  left: 50%; /* Center the snackbar */
  bottom: 30px; /* 30px from the bottom */
}

/* Show the snackbar when clicking on a button (class added with JavaScript) */
#snackbar.show {
  visibility: visible; /* Show the snackbar */
  /* Add animation: Take 0.5 seconds to fade in and out the snackbar.
  However, delay the fade out process for 2.5 seconds */
  -webkit-animation: fadein 0.5s;
  animation: fadein 0.5s;
}

/* Animations to fade the snackbar in and out */
@-webkit-keyframes fadein {
  from {bottom: 0; opacity: 0;}
  to {bottom: 30px; opacity: 1;}
}

@keyframes fadein {
  from {bottom: 0; opacity: 0;}
  to {bottom: 30px; opacity: 1;}
}
</style>
